module.exports = __webpack_public_path__ + "assets/media/1.1a66a2c7.wav";